// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const classNames = require('classnames');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const HireCardNameSelector = require('components/hire/hireCardNameSelector/hireCardNameSelector');

// @ commons
const { OKLink } = require('commonsComponents/OKLink');
const { OKMessage } = require('commonsComponents/OKMessage');

// @constants
const cardImageIds = [
    'B.501.003.003',
    'B.501.003.022',
    'B.501.003.021',
];
const {
    CREDIT_CARD_REVOLVING_PROCESS,
} = require('constants/flagBasedFeatures');

class HireCardPremiumPackStep2 extends React.Component {

    render() {
        const {
            extraImage,
            immFlagBasedFeatures,
            immHireCardImageSelector,
            immHireCardNameSelector,
        } = this.props;

        const disclaimerPersonalInfoUrl = formatText('disclaimerPersonalInfo-premiumPackLinkUrl');
        const messageContainerClasses = classNames('hire-card-premium-pack__message-container', {
            'hire-card-premium-pack__message-container--border-top': immHireCardNameSelector.get('names').size === 1,
            'hire-card-premium-pack__message-container--hidden': !immFlagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS)
        });

        return (
            <article className="hire-card-premium-pack__step-two">
                <FormattedText
                    className="hire-card-premium-pack__step-title"
                    value="hireCardPremiumPack-step2Title"
                />
                <HireCardImageSelector
                    cardImageIds={cardImageIds}
                    extraClass="hire-card-premium-pack__card-image-selector"
                    extraImage={extraImage}
                    immHireCardImageSelector={immHireCardImageSelector}
                />
                <HireCardNameSelector
                    borderTop={true}
                    immHireCardNameSelector={immHireCardNameSelector}
                />
                <div className={messageContainerClasses}>
                    <OKMessage type="informative">
                        <FormattedText value="disclaimerPersonalInfo-premiumPackMsg" />
                        &nbsp;
                        <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                            <FormattedText value="disclaimerPersonalInfo-premiumPackLinkText" />
                        </OKLink>
                    </OKMessage>
                </div>
            </article>
        );
    }
}

HireCardPremiumPackStep2.propTypes = {
    extraImage: PropTypes.string,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardNameSelector: PropTypes.object.isRequired,
};

module.exports = HireCardPremiumPackStep2;
